<template>
    <div class="tabs">
        <ul>
            <li v-for="(value, key) in props.options" :key="key" :class="{ 'is-active': model === key }">
                <a @click="selectTab(key)">{{ value }}</a>
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
    const props = defineProps<{ options: Record<string, string> }>();

    const model = defineModel();

    function selectTab(tab: string) {
        model.value = tab;
    }
</script>

<style scoped></style>
